import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useFormikContext } from 'formik';
import MarriageForm from './form';
import { AccordionTitle } from 'shell/components/shared/accordion-title';
import { RegistrationWidowhoodFormVM } from 'mutation/view-models/registration-widowhood';

interface MarriageProps {
  disabled?: boolean;
  isEditMode?: boolean;
}

const MarriageComponent = ({ disabled, isEditMode }: MarriageProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const formContext = useFormikContext<RegistrationWidowhoodFormVM>();

  const onFieldMarriageChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('marriage', {
        ...formContext.values.marriage,
        [key]: value,
      });
    },
    [formContext.values.marriage, formContext.setFieldValue]
  );

  const onFieldsMarriageChange = useCallback(
    (values) => {
      formContext.setFieldValue('marriage', {
        ...formContext.values.marriage,
        ...values,
      });
    },
    [formContext.values.marriage, formContext.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-marriage-content"
        id="panel-person-marriage-header"
        expandIcon={<ExpandMore />}
      >
        <AccordionTitle isEditMode={isEditMode}>Matrimonio/Unione civile</AccordionTitle>
      </AccordionSummary>
      <AccordionDetails>
        <MarriageForm
          disabled={disabled}
          values={formContext.values.marriage}
          civilUnionValues={formContext.values.civilUnion}
          civilStatus={formContext.values.civilStatus?.oldStatus || ''}
          onChange={onFieldMarriageChange}
          onChanges={onFieldsMarriageChange}
          isEditMode={isEditMode}
        />
      </AccordionDetails>
    </Accordion>
  );
};

MarriageComponent.displayName = 'Accordion marriage component';

const Marriage = memo(MarriageComponent);

export default Marriage;
